import { CurrencyDispatcher, HeroRosterDispatcher, UIDispatcher } from '~/flux/dispatchers';
import mutationDismissHero from '~/graphql/hero/mutationDismissHero';
import { logError } from '~/logger';

export default async function dismissHero(
  { playerId }: { playerId: string | null },
  action: { heroHandle: string }
) {
  try {
    if (!playerId) return;
    const result = await mutationDismissHero({ playerId, heroHandle: action.heroHandle });

    CurrencyDispatcher.handleCurrencyAction({
      actionType: CurrencyDispatcher.NEW_CURRENCY_BALANCE,
      currency1: result.currency1,
    });

    HeroRosterDispatcher.handleHeroRosterAction({
      actionType: HeroRosterDispatcher.HERO_DISMISSED,
      hero_roster: result.hero_roster,
      loadouts: result.loadouts,
      hero_builds: result.hero_builds,
    });

    const nextUnlockedEntry = Object.entries(result.hero_roster).find(
      ([, h]) => (h?.level ?? 0) > 0
    );
    if (nextUnlockedEntry && nextUnlockedEntry[0] !== action.heroHandle) {
      UIDispatcher.handleUIAction({
        actionType: UIDispatcher.SET_FOCUSED_HERO,
        hero_handle: nextUnlockedEntry[0],
      });
    }
  } catch (err) {
    logError(err, { module: 'HeroRosterStore', func: 'dismissHero' });
  }
}
